import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Navbar: React.FC = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="navbar">
      <a className="nav-call" href="tel:+917896353325" aria-label="Call Wevatar now">
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M7.1 4.5 9 4c.7-.2 1.4.2 1.7.9l.9 2.2c.2.6.1 1.2-.4 1.7l-1 1c.8 1.7 2.2 3.1 3.9 3.9l1-1c.5-.5 1.1-.6 1.7-.4l2.2.9c.7.3 1.1 1 .9 1.7l-.5 1.9c-.2.8-.9 1.3-1.7 1.3C9.6 18.1 3.9 12.4 3.9 4.8c0-.8.5-1.5 1.3-1.7Z" fill="currentColor" />
        </svg>
        <span>Call</span>
      </a>
      <div className="nav-brand">
        <Link to="/" aria-label="Wevatar home" onClick={() => setMenuOpen(false)}>
          <img
            src={`${process.env.PUBLIC_URL}/wevatar_logo.png`}
            alt="Wevatar logo"
            className="nav-logo"
          />
          <span>Wevatar</span>
        </Link>
      </div>
      <button
        className={`nav-toggle ${menuOpen ? 'open' : ''}`}
        onClick={() => setMenuOpen((prev) => !prev)}
        aria-label="Toggle navigation menu"
        aria-expanded={menuOpen}
      >
        <span />
        <span />
        <span />
      </button>
      <div
        className={`nav-backdrop ${menuOpen ? 'open' : ''}`}
        onClick={() => setMenuOpen(false)}
        aria-hidden="true"
      />
      <ul className={`nav-links ${menuOpen ? 'open' : ''}`}>
        <li><Link to="/services" onClick={() => setMenuOpen(false)}>Services</Link></li>
        <li><Link to="/portfolio" onClick={() => setMenuOpen(false)}>Portfolio</Link></li>
        <li><Link to="/about" onClick={() => setMenuOpen(false)}>About</Link></li>
        <li><Link to="/contact" onClick={() => setMenuOpen(false)}>Contact</Link></li>
      </ul>
    </nav>
  );
};

export default Navbar;
